import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link, useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ActivateIcon from '@mui/icons-material/CheckCircle'; // Import the activate icon
import VisibilityIcon from '@mui/icons-material/Visibility'; // Import the visibility icon
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { saveData, getData, openDB } from '../../../utils/db';
import { fetchData, deleteData, activateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import BillPrint from './Bill';
import ReactDOM from 'react-dom';
import PrintIcon from '@mui/icons-material/Print';
import Button from '@mui/material/Button';
import {
    Add as AddIcon,
} from '@mui/icons-material';


function ReceiptIndex() {
    const history = useHistory();

    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null); // Track the item ID to delete
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const { isAuthenticated, companyId, userId, permissions, logout, token } = useAuth();

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

    }, [isAuthenticated, companyId, token, logout]);


    const hasCreateTransactionPermission = permissions.includes('Create Transaction');
    const hasEditTransactionPermission = permissions.includes('Edit Transaction');
    const hasDeleteTransactionPermission = permissions.includes('Delete Transaction');

    useEffect(() => {

        fetchtableData();

    }, []);


    const fetchtableData = async () => {

        fetchData('ReceiptApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode == '1111') {
                    console.log(response);
                    setData(response.response_data);
                }
            })
            .catch((error) => {
                console.error('Error fetching Receipt Details:', error);
            });


    };



    const handleDelete = async () => {
        deleteData('ReceiptApi', `${deleteItemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
                setDeleteItemId(null); // Reset the item ID
                setConfirmDialogOpen(false); // Close the dialog
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });

    };

    const handleActivate = (itemId) => {
        activateData('ReceiptApi', `${itemId}`, token)
            .then((response) => {
                fetchtableData(); // Refresh data after deletion
            })
            .catch((error) => {
                // Handle errors for the activation request
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    const handleCreateNewClick = (page) => {
        history.push(`/${page}`);
    };

    function formatDate(dateString) {
        const options = { year: 'numeric', month: '2-digit', day: '2-digit' };
        const formattedDate = new Date(dateString).toLocaleDateString('en-GB', options);
        return formattedDate;
    }


    const handlePrint = async (rid) => {
        try {
            // Fetch data
            const response = await fetchData('ReceiptApi', `/ReceiptPrint/${rid}`, token);
            const labelData = Array.isArray(response.response_data) ? response.response_data : [response.response_data];

            // Create iframe
            const iframe = document.createElement('iframe');
            iframe.style.display = 'none';
            document.body.appendChild(iframe);

            // Write component content to iframe
            const iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
            iframeDocument.write('<html><head><style>@media print { header, footer { display: none !important; } }</style></head><body>');

            ReactDOM.render(
                <BillPrint labelData={labelData} onClose={() => document.body.removeChild(iframe)} />,
                iframeDocument.body
            );

            iframeDocument.write('</body></html>');
            iframeDocument.close();

            // Print the content
            iframe.contentWindow.print();

        } catch (error) {
            console.error('Error printing Estimate:', error);
        }

    };

    return (
        <div className="w-full max-w-sm container mt-6 mx-auto">

            <div className='w-full mb-2 flex'>
                {/* <h4 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', fontWeight: 'bolder' }}>Receipt</h4> */}
                <h6 className='productHead flex-grow linkcolor' style={{ color: 'black', fontFamily: 'Georgia, serif', fontWeight: 'bolder' }}>RECEIPT</h6>
                <Button
                    component={Link}
                    to="/ReceiptCreate"
                    className="linkcolor"
                    style={{ marginLeft: '8px', fontWeight: 'bolder' }}
                >
                    <AddIcon /> CREATE
                </Button>
            </div>

            <div className='w-full mb-5 flex' style={{ maxHeight: '490px', overflowY: 'auto' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#090040' }}> {/* Set background color */}
                            <TableRow>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', color: 'white', padding: '5px', textTransform: 'uppercase', fontSize: '12px' }}>Ref Date</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', color: 'white', padding: '5px', textTransform: 'uppercase', fontSize: '12px' }}>Ref No</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', color: 'white', padding: '5px', textTransform: 'uppercase', fontSize: '12px' }}>Party</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', textAlign: 'right', color: 'white', padding: '5px', textTransform: 'uppercase', fontSize: '12px' }}>Amount</TableCell>
                                <TableCell sx={{ backgroundColor: '#090040', borderBottom: '1px solid #ddd', color: 'white', padding: '5px', textTransform: 'uppercase', fontSize: '12px', textAlign: 'right' }}>Actions</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody sx={{ backgroundColor: '#D5F5E3' }}>
                            {data.map(item => (
                                <TableRow key={item.Id} className={item.IsActive ? 'activeRow' : 'inactiveRow'}>
                                    <TableCell sx={{ height: '40px', padding: '2px', width: '13%' }}>{formatDate(item.ReferenceDate)}</TableCell>
                                    <TableCell sx={{ height: '40px', padding: '2px', width: '13%' }}>{item.ReferenceNo}</TableCell>
                                    <TableCell sx={{ height: '40px', padding: '2px', width: '35%' }}>{item.PartyName}</TableCell>
                                    <TableCell sx={{ height: '40px', padding: '2px', textAlign: 'right', width: '15%' }}>{item.Amount.toFixed(2)}</TableCell>
                                    <TableCell sx={{ height: '40px', padding: '2px', width: '10%', marginLeft: '10px', textAlign: 'right' }}>
                                        {hasEditTransactionPermission && item.IsActive && (
                                            <Link to={`/ReceiptEdit/${item.Id}`}>
                                                <IconButton>
                                                    <EditIcon style={{ color: '#4682B4' }} />
                                                </IconButton>
                                            </Link>

                                        )}


                                        <IconButton onClick={() => handlePrint(item.Id)}>
                                            <PrintIcon style={{ color: '#5F2F53' }} />
                                        </IconButton>


                                        {hasDeleteTransactionPermission && (
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                {item.IsActive ? <DeleteIcon style={{ color: 'red' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        )}

                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        {/* Delete confirmation dialog */}
                        <Dialog
                            open={confirmDialogOpen}
                            onClose={closeConfirmDialog}
                            aria-labelledby="alert-dialog-title"
                            aria-describedby="alert-dialog-description"
                        >
                            <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                            <DialogContent>
                                <DialogContentText id="alert-dialog-description">
                                    Are you sure you want to delete this record?
                                </DialogContentText>
                            </DialogContent>

                            <DialogActions>
                                <button
                                    onClick={closeConfirmDialog}
                                    style={{
                                        backgroundColor: '#dc3545',
                                        color: '#ffffff',
                                        border: '1px solid #dc3545',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                        marginRight: '8px',
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleDelete}
                                    style={{
                                        backgroundColor: '#28a745',
                                        color: '#ffffff',
                                        border: '1px solid #28a745',
                                        borderRadius: '4px',
                                        padding: '8px 16px',
                                        cursor: 'pointer',
                                    }}
                                >
                                    Confirm
                                </button>
                            </DialogActions>

                        </Dialog>
                    </Table>
                </TableContainer>
            </div>
        </div>

    );
}

export default ReceiptIndex;

